import { render } from "./nested.vue?vue&type=template&id=7770bb0d&scoped=true"
import script from "./nested.vue?vue&type=script&lang=js"
export * from "./nested.vue?vue&type=script&lang=js"

import "./nested.vue?vue&type=style&index=0&id=7770bb0d&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/barmm-admin-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7770bb0d"]])

export default __exports__